import store from '@/store';
import router from '@/router';
import { Dialog } from 'vant';
import { noop } from './util';

/**
   * 检查用户是否缴纳押金
   * @param {boolean} needUpdata 是否需要更新wallet数据 可选
   * @param {object} showModalOpt 二次弹框UI配置 可选
   */
// eslint-disable-next-line import/prefer-default-export
export async function checkDeposit({
  needUpdata = true,
  showModalOpt = {
    title: '您还未缴纳押金，现在前往缴纳押金？',
    confirmButtonText: '缴押金',
    cancelButtonText: '再逛逛',
  },
} = {}) {
  if (needUpdata) {
    await store.dispatch('wallet/getCommon');
  }
  const { wallet } = store.state;
  if (!wallet.deposit) {
    // 缴纳押金
    Dialog.confirm(showModalOpt).then(() => {
      router.push('/deposit/pay');
    }).catch(noop);
    throw new Error('无押金');
  }
}


/**
   * 检查用户是否缴纳押金
   * @param {boolean} needUpdata 是否需要更新wallet数据 可选
   * @param {object} showModalOpt 二次弹框UI配置 可选
   */
// eslint-disable-next-line import/prefer-default-export
export async function checkPackage({
  needUpdata = true,
  showModalOpt = {
    title: '您还未购买套餐，现在前往购买套餐？',
    confirmButtonText: '选套餐',
    cancelButtonText: '再逛逛',
  },
} = {}) {
  if (needUpdata) {
    await store.dispatch('wallet/getCommon');
  }
  const { wallet } = store.state;
  if (wallet.packageInfo.length === 0) {
    // 购买套餐
    Dialog.confirm(showModalOpt).then(() => {
      router.push('/package');
    }).catch(noop);

    throw new Error('无押金');
  }
}
